import { render } from "./HeroSection1.vue?vue&type=template&id=ba347370&ts=true"
import script from "./HeroSection1.vue?vue&type=script&lang=ts"
export * from "./HeroSection1.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__